import styled from 'styled-components';

export const TaskRepeatOptionsList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`;
